import { createStaticReducer } from '../../../../packages/redux-utils';
import { TUserState } from '../../types/user';

const defaultState: TUserState = {
  isAuthenticated: false,
};

export const userReducer = createStaticReducer<TUserState>(defaultState);
